var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg025MalaiKofta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m495.891 93.89c21.479-21.479 21.479-56.302 0-77.781-21.479-21.479-56.303-21.479-77.781 0l-24.186 24.186c-39.807-25.506-87.138-40.295-137.924-40.295-141.385 0-256 114.615-256 256 0 50.786 14.789 98.117 40.295 137.924l-24.186 24.186c-21.479 21.479-21.479 56.302 0 77.781 21.479 21.479 56.303 21.479 77.781 0l24.186-24.186c39.807 25.506 87.138 40.295 137.924 40.295 141.385 0 256-114.615 256-256 0-50.786-14.789-98.117-40.295-137.924zm-56.569-56.568c9.763-9.763 25.593-9.763 35.356 0 9.763 9.763 9.763 25.593 0 35.356l-20.844 20.844c-10.609-12.902-22.454-24.747-35.356-35.356zm-73.928 108.072c5.858-5.858 15.355-5.858 21.213 0l20 20c5.858 5.858 5.858 15.355 0 21.213s-15.355 5.858-21.213 0l-20-20c-5.858-5.858-5.858-15.356 0-21.213zm-109.394-84.394c30.327 0 55 24.673 55 55s-24.673 55-55 55-55-24.673-55-55 24.673-55 55-55zm.606 195.606-20 20c-5.858 5.858-15.355 5.858-21.213 0s-5.858-15.355 0-21.213l20-20c5.858-5.858 15.355-5.858 21.213 0s5.858 15.356 0 21.213zm-141.212-111.212 20-20c5.858-5.858 15.355-5.858 21.213 0s5.858 15.355 0 21.213l-20 20c-5.858 5.858-15.355 5.858-21.213 0s-5.858-15.356 0-21.213zm-42.716 329.284c-9.763 9.763-25.593 9.763-35.356 0-9.763-9.763-9.763-25.593 0-35.356l20.844-20.844c10.609 12.902 22.454 24.747 35.356 35.356zm93.928-78.072c-5.858 5.858-15.355 5.858-21.213 0l-20-20c-5.858-5.858-5.858-15.355 0-21.213s15.355-5.858 21.213 0l20 20c5.858 5.858 5.858 15.356 0 21.213zm-40.606-85.606c-30.327 0-55-24.673-55-55s24.673-55 55-55 55 24.673 55 55-24.673 55-55 55zm130 140c-30.327 0-55-24.673-55-55s24.673-55 55-55 55 24.673 55 55-24.673 55-55 55zm80-130c-30.327 0-55-24.673-55-55s24.673-55 55-55 55 24.673 55 55-24.673 55-55 55zm90.606 25.606-20 20c-5.858 5.858-15.355 5.858-21.213 0s-5.858-15.355 0-21.213l20-20c5.858-5.858 15.355-5.858 21.213 0s5.858 15.356 0 21.213z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 396,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 256,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 336,
    cy: 266,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 116,
    r: 25
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg025MalaiKofta);
export default __webpack_public_path__ + "static/media/025-malai-kofta.48bf4a498438bf7b850ff09eb5b7ca70.svg";
export { ForwardRef as ReactComponent };